import * as React from 'react';
import { useTrackedPointer } from '../utils/useTrackedPointer';
export function useSuggestMouseEvents(setSelectedItemIndex) {
  var _useTrackedPointer = useTrackedPointer(),
    wasPointerMoved = _useTrackedPointer.wasPointerMoved,
    pointerUpdate = _useTrackedPointer.pointerUpdate;
  var onMouseMove = React.useCallback(function (index) {
    return function (e) {
      if (wasPointerMoved(e)) {
        setSelectedItemIndex(index);
      }
    };
  }, [setSelectedItemIndex, wasPointerMoved]);
  var onMouseLeave = React.useCallback(function (e) {
    if (wasPointerMoved(e)) {
      setSelectedItemIndex(undefined);
    }
  }, [setSelectedItemIndex, wasPointerMoved]);
  var onMouseEnter = React.useCallback(function (e) {
    pointerUpdate(e);
  }, [pointerUpdate]);
  return {
    onMouseMove: onMouseMove,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  };
}